var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9991 13.5326H2.42622C1.08721 13.5326 0.000488281 12.4766 0.000488281 11.1755C0.000488281 9.87435 1.08721 8.81836 2.42622 8.81836H24.9991C26.3381 8.81836 27.4248 9.87435 27.4248 11.1755C27.4248 12.4766 26.3381 13.5326 24.9991 13.5326Z",
    fill: "#1A103F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9986 4.71426H2.42573C1.08673 4.71426 0 3.65827 0 2.35713C0 1.05599 1.08673 0 2.42573 0H24.9986C26.3376 0 27.4243 1.05599 27.4243 2.35713C27.4243 3.65827 26.3376 4.71426 24.9986 4.71426Z",
    fill: "#1A103F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9991 22.3461H2.42622C1.08721 22.3461 0.000488281 21.2901 0.000488281 19.989C0.000488281 18.6878 1.08721 17.6318 2.42622 17.6318H24.9991C26.3381 17.6318 27.4248 18.6878 27.4248 19.989C27.4248 21.2901 26.3381 22.3461 24.9991 22.3461Z",
    fill: "#1A103F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerDark);
export default __webpack_public_path__ + "static/media/hamburger-dark.5b954207eb25de08b3345edb555d5c97.svg";
export { ForwardRef as ReactComponent };